import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { CalenderDialogComponent } from "src/app/shared/components/calender-dialog/calender-dialog.component";
import { EmployeeAssignForCustomiseComponent } from "src/app/shared/components/employee-assign-for-customise/employee-assign-for-customise.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { InvoiceForMainComponent } from "../../new-v2-component/invoice-for-main/invoice-for-main.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { SlotTimingsComponent } from "../../new-v2-component/slot-timings/slot-timings.component";
import { HttpClient } from "@angular/common/http";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { InvoiceForFitnessComponent } from "src/app/shared/components/invoice-for-fitness/invoice-for-fitness.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { InvoiceForReportOnlyComponent } from "src/app/shared/components/invoice-for-report-only/invoice-for-report-only.component";

@Component({
  selector: "sm-new-produce-bill",
  templateUrl: "./new-produce-bill.component.html",
  styleUrls: ["./new-produce-bill.component.scss"],
})
export class NewProduceBillComponent implements OnInit,OnDestroy {
  countryInfo:any = typeof sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT) == 'string' ? JSON.parse(sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)!) : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT)
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  panelState: any = [true, false, false, false, false];
  public newbookingData: any = {
    price: 0,
    discount: 0
  }
  loader: boolean = false
  selectedBookingType: number = 1
  apisub: Subscription;
  selectedBusiness: any;
  selectedServiceType: string = "1";
  businessListData: any = [];
  taxSlabData: any = [];
  productsList: any = [];
  serviceList: any = [];
  discountInfo: any = null;
  form: FormGroup;
  isEmployeeAndHasBusinessButDoesNotHaveAccess:boolean = false
  constructor(
    private navservice: NavigationService, 
    private fb: FormBuilder,private http: HttpClient,
    private router: Router,
    private snackbar: MatSnackBar,
    private _modelRef: MatDialog,
    private loaderservice: LoaderServiceService,
    private dialog:MatDialog,
    private apiservice: ApiService) {
    this.navservice.hideSidebarAndNav = false;
    this.form = this.fb.group({
      items: this.fb.array([])
    });
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
      ) {
        this.businessListData = [];
        if (resdata.result) {
          this.businessListData = resdata.result;
           this.businessListData.forEach((element: any) => {
            // Parse if string
            element.employee_functionality_list =
              typeof element.employee_functionality_list === "string"
                ? JSON.parse(element.employee_functionality_list)
                : element.employee_functionality_list;

            const list = element.employee_functionality_list || [];

            // Set defaults
            element.member_access = 0;
            element.customer_access = 0;
            element.service_access = 0;
            element.bookings_access = 0;
            
            if (Array.isArray(list)) {
              list.forEach((fn: any) => {
                const access = fn?.access_status === 1 ? 1 : 0;
                const name = fn?.functionality_name || "";

                switch (name) {
                  case "Member management":
                    element.member_access = access;
                    break;

                  case "Customer management":
                    element.customer_access = access;
                    break;

                  case "Services & Packages":
                    element.service_access = access;
                    break;

                  case "Booking history":
                    element.bookings_access = access;
                    break;
                    
                  case "Shop/In-Premise operation":
                    element.shop_bookings_access = access;
                    break;

                  case "Home service operation":
                    element.home_bookings_access = access;
                    break;

                  case "Virtual service operation":
                    element.virtual_bookings_access = access;
                    break;

                  case "Invoice history":
                    element.invoice_history_access = access;
                    break;
                    
                  case "Shop/In-Premise Invoicing":
                    element.shop_invoice_access = access;
                    break;

                  case "Home service invoicing":
                    element.home_invoice_access = access;
                    break;

                  case "Virtual service invoicing":
                    element.virtual_invoice_access = access;
                    break;


                }
              });
            }
          });
          let checkForAccessLength = this.businessListData.length
          this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0 // Add the isSelected property
            }))
            .filter((element: any) => 
              (element.is_owner == 1 )|| (
                element.entitySubscriptionInfo && 
                element.entitySubscriptionInfo !== 'null' &&
                element.employeeSubscriptionInfo &&
                element.employeeSubscriptionInfo !== 'null' && element.employee_status == 1 
               && (
                  (element.shop_invoice_access == 1 && element.shop_service_status != 2) ||
                  (element.home_invoice_access == 1 && element.home_service_status != 2) ||
                  (element.virtual_invoice_access == 1 && element.virtual_service_status != 2)
                 )
              
              )
            );
            if(checkForAccessLength - this.businessListData.length > 0){
              this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true
            }  
          if(this.businessListData.length > 0){
            this.businessListData[0].isSelected = 1;
            this.selectedBusiness = this.businessListData[0];
         if (this.selectedBusiness.shop_service_status != 2 && this.getSectionVisibleStatus('shop_invoice_access')) {
              this.selectedServiceType = "1";
            } else if (this.selectedBusiness.home_service_status != 2 && this.getSectionVisibleStatus('home_invoice_access')) {
              this.selectedServiceType = "0";
            } else if (this.selectedBusiness.virtual_service_status != 2 && this.getSectionVisibleStatus('virtual_invoice_access')) {
              this.selectedServiceType = "2";
            }
            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
              this.selectedBusiness.entity_public_hash_id
            );
            sessionStorage.setItem('shop_service_status', this.selectedBusiness.shop_service_status)
            sessionStorage.setItem('home_service_status',this.selectedBusiness.home_service_status)
            sessionStorage.setItem('virtual_service_status',this.selectedBusiness.virtual_service_status)

            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_HASH,
              this.selectedBusiness.hash_id
            );
            localStorage.setItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
              this.selectedBusiness.employee_hash_id
            );
            this.isEntityForeign = this.selectedBusiness.currency == 'INR' ? '0' : '1'
  
            localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, this.isEntityForeign)
  
            let countryList: any[] = COUNTRY_CODES;
  
            let selectedCurrency = {
              currency: this.selectedBusiness.currency,
              currencySymbol: this.selectedBusiness.currency_symbol,
              countryCode: this.selectedBusiness.entity_country_code,
              code: countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code && country.currency === this.selectedBusiness.currency)?.code
            };
            sessionStorage.setItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,JSON.stringify(selectedCurrency))
  
            this.selectedCountryCode = this.countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code && country.code === selectedCurrency.code)
          } 
         
        }
        if (this.businessListData.length > 0) {
          if(this.isEntityForeign == '0'){
            this.apiservice.getEntityTaxSlabData(this.selectedBusiness.hash_id)
          }
          else if(this.isEntityForeign == '1'){
            this.apiservice.getInternationalEntityTaxSlabsData(this.selectedBusiness.hash_id)
          }

          this.apiservice.getEntityProductList(this.selectedBusiness.hash_id,'1')
          this.apiservice.getServicesTypesList(
            this.selectedBusiness.entity_public_hash_id,
            "0",
            "0"
          );
          this.apiservice.getBillDiscountData(
            this.selectedBusiness.entity_public_hash_id
          );
        } else {
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resdata);

        this.serviceList = [];
        if(resdata.result){
          if (this.selectedServiceType == "1") {
            resdata.result.forEach((element: any) => {
              if (element.shopStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resdata.result.forEach((element: any) => {
              if (element.homeStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
          else if (this.selectedServiceType == '2') {
            resdata.result.forEach((element: any) => {
              if (element.for_virtual == 1 && element.status == 1){
                element.toShow = true 
                this.serviceList.push(element);
              } 
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }

        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      // if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_FITNESS_AUTOCORRECT){
      //   this.filteredList = []
      //   if (resdata.result) {
      //     this.filteredList = resdata.result


      //   } 
        
      // }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE){
        if (resdata.result) {
          this.loaderservice.showLoader = false
          this.newbookingData.price = 0
          this.autocompleteItems = [];
          this.newbookingData.discount = 0
          this.newbookingData.customerPh = ''
          this.newbookingData.customerName = ''
           this.newbookingData.note = ''
          // this.selectedBookingType = 1
          // this.selectedServiceType = '1'
          this.completedJobs = []
          this.completedProducts = []
          this.serviceList.forEach((element:any) => {
            element.toShow = true 
          });
          this.productsList.forEach((element:any) => {
            element.toShow = true 
          });
          this.items.clear()
          this._modelRef.open(InvoiceForMainComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: JSON.parse(resdata.result).bookingHashId,
              datetime:this.selectedDate
            },
          });
          this.changeChip(1)
        } 
       
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_WITHOUT_BOOKING){
        if (resdata.result) {
          this.loaderservice.showLoader = false
          this.newbookingData.price = 0
          this.autocompleteItems = [];
          this.newbookingData.discount = 0
          this.newbookingData.customerPh = ''
          this.newbookingData.customerName = ''
           this.newbookingData.note = ''
          // this.selectedBookingType = 1
          this.changeChip(1)
          // this.selectedServiceType = '1'
          this.completedJobs = []
          this.completedProducts = []
          this.serviceList.forEach((element:any) => {
            element.toShow = true 
          });
          this.productsList.forEach((element:any) => {
            element.toShow = true 
          });
          this.items.clear()

          this._modelRef.open(InvoiceForReportOnlyComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: resdata.result[0].invoice_hash,
              entityHash: this.selectedBusiness.hash_id,
              memberHash: null
            },
          });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE_WITHOUT_BOOKING){
        if (resdata.result) {
          this.loaderservice.showLoader = false
          this.newbookingData.price = 0
          this.autocompleteItems = [];
          this.newbookingData.discount = 0
          this.newbookingData.customerPh = ''
          this.newbookingData.customerName = ''
           this.newbookingData.note = ''
          // this.selectedBookingType = 1
          this.changeChip(1)
          // this.selectedServiceType = '1'
          this.completedJobs = []
          this.completedProducts = []
          this.serviceList.forEach((element:any) => {
            element.toShow = true 
          });
          this.productsList.forEach((element:any) => {
            element.toShow = true 
          });
          this.items.clear()
          this._modelRef.open(InvoiceForReportOnlyComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: resdata.result[0].invoice_hash,
              entityHash: this.selectedBusiness.hash_id,
              memberHash: null
            },
          });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD){
        if (resdata.result) {
          this.loaderservice.showLoader = false   
          // this.snackbar.open('Payment recorded successfully.', 'Ok', {
          //   duration: 3000,
          // });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD){
        if (resdata.result) {
          this.loaderservice.showLoader = false   
          // this.snackbar.open('Payment recorded successfully.', 'Ok', {
          //   duration: 3000,
          // });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE){
        if (resdata.result) {
          this.loaderservice.showLoader = false   
          // this.snackbar.open('Payment recorded successfully.', 'Ok', {
          //   duration: 3000,
          // });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD){
        if (resdata.result) {
          this.loaderservice.showLoader = false   
          // this.snackbar.open('Payment recorded successfully.', 'Ok', {
          //   duration: 3000,
          // });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE){
        if (resdata.result) {
          this.loaderservice.showLoader = false   
          this.snackbar.open('Invoice deleted successfully.', 'Ok', {
            duration: 3000,
          });
        } 
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS){
        if (resdata.result) {
          this.loaderservice.showLoader = false   
          this.snackbar.open('Invoice deleted successfully.', 'Ok', {
            duration: 3000,
          });
        } 
        
      }

      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_ENTITY_INVOICE){
        if (resdata.result) {
          this.loaderservice.showLoader = false
          this.isDropdownSelected = false
          this.newbookingData.price = 0
          this.autocompleteItems = [];
          this.newbookingData.discount = 0
          this.newbookingData.customerPh = ''
          this.newbookingData.customerName = ''
           this.newbookingData.note = ''
           this.selectedFromDate = this.selectedToDate = null
          this.items.clear()
          // this.selectedBookingType = 1
          this.changeChip(1)
          // this.selectedServiceType = '1'
          this.completedJobs = []
          this.completedProducts = []
          this.serviceList.forEach((element:any) => {
            element.toShow = true 
          });
          this.productsList.forEach((element:any) => {
            element.toShow = true 
          });
          this._modelRef.open(InvoiceForFitnessComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: resdata.result[0].invoice_hash,
              entityHash: this.selectedBusiness.hash_id,
              memberHash: this.selectedMember.hash_id,
            },
          });
        } 
       
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE){
        if (resdata.result) {
          this.loaderservice.showLoader = false
          this.isDropdownSelected = false
          this.newbookingData.price = 0
          this.autocompleteItems = [];
          this.newbookingData.discount = 0
          this.newbookingData.customerPh = ''
          this.newbookingData.customerName = ''
           this.newbookingData.note = ''
           this.selectedFromDate = this.selectedToDate = null
          this.items.clear()
          // this.selectedBookingType = 1
          this.changeChip(1)
          // this.selectedServiceType = '1'
          this.completedJobs = []
          this.completedProducts = []
          this.serviceList.forEach((element:any) => {
            element.toShow = true 
          });
          this.productsList.forEach((element:any) => {
            element.toShow = true 
          });
          this._modelRef.open(InvoiceForFitnessComponent, {
            width: '510px',
            data: {
              title: 'Invoice',
              ref: this._modelRef,
              data: resdata.result[0].invoice_hash,
              entityHash: this.selectedBusiness.hash_id,
              memberHash: this.selectedMember.hash_id,
            },
          });
        } 
       
        
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST){
        console.log(resdata);
       
        this.productsList = [];
        if(resdata.result){

          if (this.selectedServiceType == '1') {
            resdata.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true 
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == '0') {
            resdata.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1){
                element.toShow = true 
                this.productsList.push(element);
              } 
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
          else if (this.selectedServiceType == '2') {
            resdata.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1){
                element.toShow = true 
                this.productsList.push(element);
              } 
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }
        
      
        
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(resdata.result){
      
          this.taxSlabData = resdata.result.filter((item:any) => item.tax_collection_status == 1)
        }
        else{
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA){
        this.taxSlabData = []
        if(resdata.result){

          this.taxSlabData = resdata.result.filter((item:any) => item.tax_collection_status == 1)

        }
        else{
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE){
        this.autocompleteItems = []
        if(resdata.result){

          this.autocompleteItems = resdata.result

        }
        else{
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
        this.loaderForAutocomplete = false
      }
    })
  }

  ngOnInit(): void {
    this.changeChip(1)
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
    let dateobj = this.getOneHourSlot(new Date())
    this.startTime = dateobj.start
    this.endTime = dateobj.end
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
  createNewBusiness() {
    this.router.navigate(["purchased-plan"]);
  }

  selectedFromDate: any = null;
  selectedToDate: any = null;
  onSelectDate1 (type:any) {
    const dialogRef = this._modelRef.open(CalenderDialogComponent, {
      width: "350px", 
      panelClass: 'calender-dialog-container',
      data: {
        selectedDate: this.today
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.selectedBookingType = type
     
        if(type == 1){
          this.selectedFromDate = data;
          console.log(this.today);
          
        }
        else if(type == 2){
          this.selectedToDate = data;
          console.log(this.today);
          
      }
                
        // this.ngOnInit();
      }
    })
  }


  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  selectedCountryCode:any = this.countryList.find(country => country.dial_code === '+91')
  searchString: FormControl = new FormControl('');
  onCountrySelected(event: any): void {
    this.searchString.reset()
    this.countryList = COUNTRY_CODES
  }
  
  onKey() { 
    console.log(this.searchString.value);
    
    this.countryList= []; 
    this.selectSearch(this.searchString.value);       
  }
  selectSearch(value:string){
    let filter = value.toLowerCase();
    for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
        let option = COUNTRY_CODES[i];
        if (  option.name.toLowerCase().indexOf(filter) >= 0) {
            this.countryList.push( option );
        }
    }
  }

    today = new Date();
selectedDate: any = null;
onSelectDate () {
  const dialogRef = this._modelRef.open(CalenderDialogComponent, {
    width: "350px", 
    panelClass: 'calender-dialog-container',
    data: {
      selectedDate: this.today
    }
  });
  dialogRef.afterClosed().subscribe((data: any) => {
    if (data) {
      

      this.selectedBookingType = 5
      this.selectedDate = data;
      console.log(this.today);
      
      // this.ngOnInit();
    }
  })
}
changeChip(value:number){


  this.selectedDate = null
     this.selectedBookingType = value
     if(value == 1){
       this.selectedDate = new Date()
     }
     else if(value == 4){
       let tempDate = new Date()
       tempDate.setDate(tempDate.getDate() - 1);
       this.selectedDate = new Date(tempDate)
     }
     
   }
   startTime:any = null
   endTime:any = null
   onSelectSlot(){
     this.loaderservice.showLoader = true
     let dialogref = this.dialog.open(SlotTimingsComponent, {
       data:{
         isToday: this.selectedBookingType == 1 ? true : false,
         day: this.selectedDate ? new Date(this.selectedDate).getDay() + 1 : new Date(this.today).getDay() + 1,
         entityHash: this.selectedBusiness.entity_public_hash_id,
         serviceType: this.selectedServiceType
       }
     })
     dialogref.afterClosed().subscribe(res => {
       if(res){
         this.startTime = res.startTime
         this.endTime = res.endTime
       }
     })
   }

  changeServiceType(type:string){
    this.completedJobs = []
    this.completedProducts = []
    this.newbookingData.price = 0
    this.newbookingData.price = this.form.get('items')!.value
  .map((item: any) => +item.price || 0)
  .reduce((acc: number, price: number) => acc + price, 0);

    this.newbookingData.discount = 0
    this.selectedServiceType = type
    this.loaderservice.showLoader = true;
    this.apiservice.getServicesTypesList(
      this.selectedBusiness.entity_public_hash_id,
      "0",
      '0'
    );
    this.apiservice.getEntityProductList(this.selectedBusiness.hash_id,'1')
  }
  formChecker(){
    if(this.newbookingData.customerPh){
      if(this.newbookingData.customerPh.length >= 3 && this.newbookingData.customerPh.length <= 17){
        return false
      }
      else{
        return true
      }
    }
    else{
      return false
    }
  }

  completedJobs:any = []
  selectServices(item:any){
    console.log(item);
    if(item.service_type_hash){ // being added from api list
      console.log(item);
      
      const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
      console.log(index);

      if(index != -1){
       
        this.completedJobs.push(item)
        this.newbookingData.price += item.price
        
        this.serviceList[index].toShow = false
      }
      
      // this.serviceList[index].current_status = 3
     
      
    }


    else if(item.hash_id){ // being added from my list
      const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // this.completedJobs.push(this.serviceList[index])
    console.log(this.serviceList[index]);

    let data = {
      service_type_hash: item.hash_id,
      service_name: item.serviceName,
      price: (this.selectedServiceType == '0') 
      ? (item.discountStatus == 1 ? item.homeDiscountedPrice : item.home_rate)
      :(this.selectedServiceType == '1' ? item.discountStatus == 1 ? item.shopDiscountedPrice : item.shop_rate : item.discountStatus == 1 ? item.virtual_discounted_amount : item.virtual_rate ),
      note: item.note,
      img_url: item.imgUrl,
      completed_by: [{
        "cost": (this.selectedServiceType == '0') 
        ? (item.discountStatus == 1 ? item.homeDiscountedPrice : item.home_rate)
        :(this.selectedServiceType == '1' ? item.discountStatus == 1 ? item.shopDiscountedPrice : item.shop_rate : item.discountStatus == 1 ? item.virtual_discounted_amount : item.virtual_rate ),
        "employee_name": localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + '(Owner)',
        "completed_by_hash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        "competed_services_qty": 1
    }],
      description: item.description,
      current_status: 3,
      total_completed_services_qty: 1,
      "service_sac_code": item.service_sac_code,
      "tax_slab_hash": item.tax_slab_hash,
    }

    this.completedJobs.push(data)
    this.newbookingData.price += data.price
    this.serviceList[index].toShow = false
    }
    
    console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount()
  }

  decreaseServiceCount(item:any,index:any){
    if(this.completedJobs[index].total_completed_services_qty == 1){
  
      const index1 = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);

      this.newbookingData.price -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty
      this.serviceList[index1].toShow = true
      this.completedJobs.splice(index,1)
    }
    
    else{
    
  
      const index1 = item.completed_by.findIndex( (x:any)=> x.completed_by_hash == localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID));
      console.log(index1);
      
     
      
    
      this.newbookingData.price -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty
      if(index1 == -1){
        if(item.completed_by[item.completed_by.length-1].competed_services_qty == 1){
          item.completed_by.splice(item.completed_by.length-1,1)
        }
        else{
          item.completed_by[item.completed_by.length-1].competed_services_qty--;
          item.completed_by[item.completed_by.length-1].cost -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty
        }
        // item.completed_by.splice(item.completed_by.length-1,1)
      }
      else{
        if(item.completed_by[index1].competed_services_qty == 1){
          item.completed_by.splice(index1,1)
        }else{
  
          item.completed_by[index1].cost -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty 
          item.completed_by[index1].competed_services_qty -= 1 
        }
    
      }
  
      this.completedJobs[index].price -= this.completedJobs[index].price/this.completedJobs[index].total_completed_services_qty 
      this.completedJobs[index].total_completed_services_qty--
    }
    this.calculateDiscount()
  }


  increaseServiceCount(item:any,index:any){
    this.newbookingData.price += item.price/item.total_completed_services_qty
  
  
    const index1 = item.completed_by.findIndex( (x:any)=> x.completed_by_hash == localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID));
    console.log(index1);
    
   
    
  
    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    // let service_cost
    // if(this.selectedServiceType == '0'){
    //   if(this.completedJobs[index].discountStatus == 1){
    //     service_cost = this.completedJobs[index].homeDiscountedPrice
    //     // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
    //   }
    //   else if(this.completedJobs[index].discountStatus == 0){
    //     service_cost = this.completedJobs[index].home_rate
    //     // this.newbookingData.price += this.completedJobs[index].home_rate
    //   }
    // }
    // else if(this.selectedServiceType == '1'){
    //   if(this.completedJobs[index].discountStatus == 1){
    //     service_cost = this.completedJobs[index].shopDiscountedPrice
    //     // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
    //   }
    //   else if(this.completedJobs[index].discountStatus == 0){
    //     service_cost = this.completedJobs[index].shop_rate
    //     // this.newbookingData.price += this.completedJobs[index].shop_rate
    //   }
    // }
  
    if(index1 == -1){
      item.completed_by.push({
        "cost": item.price,
        "employee_name": localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + '(Owner)',
        "completed_by_hash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
        "competed_services_qty": 1
    })
    }
    else{
  
      item.completed_by[index1].cost += item.price/item.total_completed_services_qty
      item.completed_by[index1].competed_services_qty += 1 
  
    }
    item.price += item.price/item.total_completed_services_qty 
    item.total_completed_services_qty++
    this.calculateDiscount()
  }

  assignEmployee(item:any, index:any){
    console.log(item);
    
    let dialogref = this._modelRef.open(EmployeeAssignForCustomiseComponent,{
      width: '600px',
      disableClose: true,
      data: {
        data: item,
        serviceType: this.selectedServiceType
      }
    })

    dialogref.afterClosed().subscribe(res =>{
      if(res){
        console.log(res);
        
          this.completedJobs[index] = res
          console.log(this.completedJobs)
          if(!res.completed_by || res.completed_by.length == 0){
            const index1 = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
            this.serviceList[index1].toShow = true
            this.completedJobs.splice(index,1)
          }
          this.newbookingData.price = 0
          this.completedJobs.forEach((element:any) => {
            element.completed_by.forEach((item:any) => {
              this.newbookingData.price += item.cost
            });
          });
          this.calculateDiscount()
      }
    })
 
  }
  removeCompletedJobs(item:any){
    
    const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
    const index1 = this.completedJobs.findIndex( (x:any)=>x.service_type_hash == item.service_type_hash);


    this.newbookingData.price -= this.completedJobs[index1].price
    this.serviceList[index].toShow = true
    this.completedJobs.splice(index1,1)
    this.calculateDiscount()
  }

  changeServicePrice(item:any){
    console.log(item.price);
    this.newbookingData.price = 0
    this.completedJobs.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.completedProducts.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.form.get('items')!.value.forEach((element:any) => {
      this.newbookingData.price += +(element.price)
    })
    
    this.checkIfEmpty()
    this.calculateDiscount()
  }
  changeProductPrice(item:any){
    console.log(item.price);
    this.newbookingData.price = 0
    this.completedJobs.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.completedProducts.forEach((element:any) => {
      this.newbookingData.price += element.price
    });
    this.form.get('items')!.value.forEach((element:any) => {
      this.newbookingData.price += +(element.price)
    })

    this.checkIfEmptyForProduct()
    this.calculateDiscount()
  }
  emptyCheck: boolean = false
  checkIfEmpty(){
   return this.completedJobs.some(
    (element: any) => element.price === "" || element.price == null
  );
    
  }
  emptyCheckForProduct: boolean = false
checkIfEmptyForProduct(){
  return this.completedProducts.some(
    (element: any) => element.price === "" || element.price == null
  );
  
}

  selectBusiness(index: any) {
    // this.filteredList = []
    this.autocompleteItems = [];
    this.newbookingData.price = 0
    this.newbookingData.discount = 0
    this.newbookingData.customerPh = ''
    this.newbookingData.customerName = ''
     this.newbookingData.note = ''
    this.selectedBookingType = 1
    this.selectedServiceType = '1'
    this.completedJobs = []
    this.completedProducts = []
    this.items.clear()
    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];
   if (this.selectedBusiness.shop_service_status != 2 && this.getSectionVisibleStatus('shop_invoice_access')) {
              this.selectedServiceType = "1";
            } else if (this.selectedBusiness.home_service_status != 2 && this.getSectionVisibleStatus('home_invoice_access')) {
              this.selectedServiceType = "0";
            } else if (this.selectedBusiness.virtual_service_status != 2 && this.getSectionVisibleStatus('virtual_invoice_access')) {
              this.selectedServiceType = "2";
            }
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      this.selectedBusiness.entity_public_hash_id
    );
    sessionStorage.setItem('shop_service_status', this.selectedBusiness.shop_service_status)
            sessionStorage.setItem('home_service_status',this.selectedBusiness.home_service_status)
            sessionStorage.setItem('virtual_service_status',this.selectedBusiness.virtual_service_status)

    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_HASH,
      this.selectedBusiness.hash_id
    );
    localStorage.setItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
            this.selectedBusiness.employee_hash_id
          );
    this.isEntityForeign = this.selectedBusiness.currency == 'INR' ? '0' : '1'

    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, this.isEntityForeign)

    let countryList: any[] = COUNTRY_CODES;

    let selectedCurrency = {
      currency: this.selectedBusiness.currency,
      currencySymbol: this.selectedBusiness.currency_symbol,
      countryCode: this.selectedBusiness.entity_country_code,
      code: countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code && country.currency === this.selectedBusiness.currency)?.code
    };
    sessionStorage.setItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,JSON.stringify(selectedCurrency))

    this.selectedCountryCode = this.countryList.find(country => country.dial_code === this.selectedBusiness.entity_country_code  && country.code === selectedCurrency.code)
    this.loaderservice.showLoader = true
    if(this.isEntityForeign == '0'){
      this.apiservice.getEntityTaxSlabData(this.selectedBusiness.hash_id)
    }
    else if(this.isEntityForeign == '1'){
      this.apiservice.getInternationalEntityTaxSlabsData(this.selectedBusiness.hash_id)
    }

    this.apiservice.getEntityProductList(this.selectedBusiness.hash_id,'1')
    this.apiservice.getServicesTypesList(
      this.selectedBusiness.entity_public_hash_id,
      "0",
      "0"
    );
    this.apiservice.getBillDiscountData(
      this.selectedBusiness.entity_public_hash_id
    );
  }

    /**------------all done and generate bill--------------- */

    serviceInfo: any = []
    serviceInfoFinalise: any = []
    completedJobs2:any = []
    completedServices:any = []
    onPost() {
      
      this.completedServices = []
      this.productInfo = []
      if(this.completedJobs.length > 0){
    
        this.completedJobs.forEach((element:any) => {
          const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
          
            this.completedServices.push({
              service_hash_id: element.service_type_hash,
              service_name: element.service_name,
              description: element.description,
              img_url: element.img_url,
              approxTime: element.approxTime ? element.approxTime : 60,
              service_cost: element.price,
              current_status: 3,
              completed_by_hash_ids: element.completed_by.map((data:any) => {
                return {
                  completedByHashId: data.completed_by_hash,
                  qty: data.competed_services_qty,
                  cost: data.cost
                }
              }),
              serviceQty: totalQty,
              "tax_slab_hash": element.tax_slab_hash, 
              "service_sac_code": element.service_sac_code
            })
      
          
         
        });
    
        this.productInfo = this.completedProducts.map((item:any) => {
          return {
            "product_name": item.product_name,
            "product_desc": item.description,
            "entity_product_hash": item.hash_id,
            "product_img_url": item.img_url,
            "product_price": item.price,
            "product_qty": item.total_completed_services_qty,
            "tax_slab_hash": item.tax_slab_hash,
            "hsn_code": item.product_hsn_code,
            "inventory_item_hash": item.inventory_item_hash,
            "purchase_unit": item.purchase_unit,
            "selling_unit": item.selling_unit,
            "selling_purchase_multiplier": item.selling_purchase_multiplier,
            "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            "selling_quantity": Math.round((+item.qty_info*item.total_completed_services_qty)*100)/100,
            "purchase_quantity": Math.round(((+item.qty_info*item.total_completed_services_qty)/item.selling_purchase_multiplier)*100)/100,
            
          }
        })
    
    
        let data = {
          bookingStatusInfo : {
            appointmentHash: "",
            assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
            assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
            entityHash:  this.selectedBusiness.hash_id, 
            bookingStatus: 4,
            price: this.newbookingData.price.toString(),
            startTime: this.startTime,
            endTime: this.endTime,
            note: this.newbookingData.note ,
            completedServices: this.completedServices,
            products: this.productInfo,
            custom_items: this.form.get('items')!.value.map((item:any) => {
              return {
                "item_name": item.name.item_name ?  item.name.item_name : item.name, 
                "item_desc": item.name.item_desc ?? '', 
                "item_inventory_hash": item.name.hash_id ?? '', 
                "item_img_url": item.name.image_thumb_url ?? '', 
                "item_qty": item.count, 
                "item_price": +item.price,
                "tax_slab_hash": item.tax_slab == 'default' ? null : item.tax_slab
              }
            }),
            bookingDate: this.formatDateString(new Date(this.selectedDate ? this.selectedDate : this.today)),
            countryCode: this.selectedCountryCode.dial_code,
            customerPh: this.newbookingData.customerPh ? this.newbookingData.customerPh : '0000000000', 
            customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
            bookingType: this.selectedServiceType,
            newCustomer: 1,
            discount: this.newbookingData.discount,
    
          }
    
          
        }
        Object.keys(data.bookingStatusInfo).forEach(key => {
          if ((data.bookingStatusInfo as any)[key] === null) {
            delete (data.bookingStatusInfo as any)[key];
          }
        });
        data.bookingStatusInfo.completedServices.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.bookingStatusInfo.products.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.bookingStatusInfo.custom_items.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        console.log(data);
        this.loaderservice.showLoader = true
        this.apiservice.updateBookingStatusWithInvoice(data)
      }  
      else {
    
    
        this.productInfo = this.completedProducts.map((item:any) => {
          return {
            "product_name": item.product_name,
            "product_desc": item.description,
            "entity_product_hash": item.hash_id,
            "product_img_url": item.img_url,
            "product_price": item.price,
            "product_qty": item.total_completed_services_qty,
            "tax_slab_hash": item.tax_slab_hash,
            "hsn_code": item.hsn_code,
            "inventory_item_hash": item.inventory_item_hash,
            "purchase_unit": item.purchase_unit,
            "selling_unit": item.selling_unit,
            "selling_purchase_multiplier": item.selling_purchase_multiplier,
            "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            "selling_quantity": Math.round((+item.qty_info*item.total_completed_services_qty)*100)/100,
            "purchase_quantity": Math.round(((+item.qty_info*item.total_completed_services_qty)/item.selling_purchase_multiplier)*100)/100,
          }
        })
    
    
        let data = {
          "customer_name": this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
          "customer_phone": this.newbookingData.customerPh ? this.newbookingData.customerPh : '0000000000',
          "customer_country_code": this.selectedCountryCode.dial_code,
          "entity_hash": this.selectedBusiness.hash_id,
          "services": this.completedServices,
          "products": this.productInfo,
          "custom_items": this.form.get('items')!.value.map((item:any) => {
            return {
              "item_name": item.name.item_name ?  item.name.item_name : item.name, 
              "item_desc": item.name.item_desc ?? '', 
              "item_inventory_hash": item.name.hash_id ?? '', 
              "item_img_url": item.name.image_thumb_url ?? '', 
              "item_qty": item.count, 
              "item_price": +item.price,
              "tax_slab_hash": item.tax_slab == 'default' ? null : item.tax_slab
            }
          }),
          "price": this.newbookingData.price,
          "discount": this.newbookingData.discount,
          "assignedToHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
          "assignedByHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
          "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          "creation_date": this.formatDateString1(this.selectedDate)
    
          
        }
        Object.keys(data).forEach(key => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });
    
     
        data.services.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.products.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.custom_items.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        console.log(data);
        this.loaderservice.showLoader = true
        if(this.isEntityForeign == '0'){
          this.apiservice.addEditEntityInvoiceWithoutBooking(data)
    
        }
        else if(this.isEntityForeign == '1'){
          this.apiservice.addEditInternationalEntityInvoiceWithoutBooking(data)
        }
      }  
    }
    productInfo:any = []
    onPostForFitness() {
      this.completedServices = []
      this.productInfo = []
      // this.completedJobs.forEach((element:any) => {
      //   const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
        
      //     this.completedServices.push({
      //       service_hash: element.service_type_hash,
      //       service_name: element.service_name,
      //       service_description: element.description,
      //       service_img_url: element.img_url,
      //       service_time: element.approxTime ? element.approxTime : 60,
      //       service_rate: element.price,
      //       current_status: 3,
      //       completed_by_hash_ids: element.completed_by.map((data:any) => {
      //         return {
      //           completedByHashId: data.completed_by_hash,
      //           qty: data.competed_services_qty,
      //           cost: data.cost
      //         }
      //       }),
      //       service_qty: totalQty,
      //       "service_sac_code": element.service_sac_code,
      //       "tax_slab_hash": element.tax_slab_hash
      //     })
    
        
       
      // });

      // this.productInfo = this.completedProducts.map((item:any) => {
      //   return {
      //     "product_name": item.product_name,
      //     "product_desc": item.description,
      //     "entity_product_hash": item.hash_id,
      //     "product_img_url": item.img_url,
      //     "product_price": item.price,
      //     "product_qty": item.total_completed_services_qty,
      //     "tax_slab_hash": item.tax_slab_hash,
      //     "hsn_code": item.product_hsn_code
      //   }
      // })


  
  
      // let data = {
      //   "customer_hash": this.selectedMember.hash_id,
      //   "customer_name": this.newbookingData.customerName,
      //   "customer_country_code": this.selectedCountryCode.dial_code,
      //   "customer_phone": this.newbookingData.customerPh,
      //   "from_date": this.selectedFromDate ?  this.formatDate1(this.selectedFromDate) : null,
      //   "entity_hash": this.selectedBusiness.hash_id,
      //   "to_date": this.selectedToDate ? this.formatDate1(this.selectedToDate) : null,
      //   "services": this.completedServices,
      //   "products": this.productInfo,
      //   "custom_items": this.form.get('items')!.value.map((item:any) => {
      //     return {
      //       "item_name": item.name.item_name ?  item.name.item_name : item.name, 
      //       "item_desc": item.name.item_desc ?? '', 
      //       "item_inventory_hash": item.name.hash_id ?? '', 
      //       "item_img_url": item.name.image_thumb_url ?? '', 
      //       "item_qty": item.count, 
      //       "item_price": +item.price,
      //       "tax_slab_hash": item.tax_slab == 'default' ? null : item.tax_slab
      //     }
      //   }),
      //   "price": this.newbookingData.price,
      //   "discount": this.newbookingData.discount,
      //   "assignedToHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
      //   "assignedByHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
      //   "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
  
        
      // }
      // Object.keys(data).forEach(key => {
      //   if ((data as any)[key] === null) {
      //     delete (data as any)[key];
      //   }
      // });
  
   
      // data.services.forEach((element:any) => {
      //   Object.keys(element).forEach(key => {
      //     if ((element as any)[key] === null) {
      //       delete (element as any)[key];
      //     }
      //   });
        
      // });
      // data.products.forEach((element:any) => {
      //   Object.keys(element).forEach(key => {
      //     if ((element as any)[key] === null) {
      //       delete (element as any)[key];
      //     }
      //   });
        
      // });
      // data.custom_items.forEach((element:any) => {
      //   Object.keys(element).forEach(key => {
      //     if ((element as any)[key] === null) {
      //       delete (element as any)[key];
      //     }
      //   });
        
      // });
      // console.log(data);
      // this.loaderservice.showLoader = true
      // if(this.isEntityForeign == '0'){
      //   this.apiservice.addEditFitnessEntityInvoice(data)

      // }
      // else if(this.isEntityForeign == '1'){
      //   this.apiservice.addEditInternationalFitnessEntityInvoice(data)
      // }
      if(this.completedJobs.length > 0){
    
        this.completedJobs.forEach((element:any) => {
          const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
          
            this.completedServices.push({
              service_hash_id: element.service_type_hash,
              service_name: element.service_name,
              description: element.description,
              img_url: element.img_url,
              approxTime: element.approxTime ? element.approxTime : 60,
              service_cost: element.price,
              current_status: 3,
              completed_by_hash_ids: element.completed_by.map((data:any) => {
                return {
                  completedByHashId: data.completed_by_hash,
                  qty: data.competed_services_qty,
                  cost: data.cost
                }
              }),
              serviceQty: totalQty,
              "tax_slab_hash": element.tax_slab_hash, 
              "service_sac_code": element.service_sac_code
            })
      
          
         
        });
    
        this.productInfo = this.completedProducts.map((item:any) => {
          return {
            "product_name": item.product_name,
            "product_desc": item.description,
            "entity_product_hash": item.hash_id,
            "product_img_url": item.img_url,
            "product_price": item.price,
            "product_qty": item.total_completed_services_qty,
            "tax_slab_hash": item.tax_slab_hash,
            "hsn_code": item.product_hsn_code,
            "inventory_item_hash": item.inventory_item_hash,
            "purchase_unit": item.purchase_unit,
            "selling_unit": item.selling_unit,
            "selling_purchase_multiplier": item.selling_purchase_multiplier,
            "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            "selling_quantity": Math.round((+item.qty_info*item.total_completed_services_qty)*100)/100,
            "purchase_quantity": Math.round(((+item.qty_info*item.total_completed_services_qty)/item.selling_purchase_multiplier)*100)/100,
          }
        })
    
    
        let data = {
          bookingStatusInfo : {
            appointmentHash: "",
            assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
            assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
            entityHash:  this.selectedBusiness.hash_id, 
            bookingStatus: 4,
            price: this.newbookingData.price.toString(),
            startTime: this.startTime,
            endTime: this.endTime,
            note: this.newbookingData.note ,
            completedServices: this.completedServices,
            products: this.productInfo,
            custom_items: this.form.get('items')!.value.map((item:any) => {
              return {
                "item_name": item.name.item_name ?  item.name.item_name : item.name, 
                "item_desc": item.name.item_desc ?? '', 
                "item_inventory_hash": item.name.hash_id ?? '', 
                "item_img_url": item.name.image_thumb_url ?? '', 
                "item_qty": item.count, 
                "item_price": +item.price,
                "tax_slab_hash": item.tax_slab == 'default' ? null : item.tax_slab
              }
            }),
            bookingDate: this.formatDateString(new Date(this.selectedDate ? this.selectedDate : this.today)),
            countryCode: this.selectedCountryCode.dial_code,
            customerPh: this.newbookingData.customerPh ? this.newbookingData.customerPh : '0000000000', 
            customerName: this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
            bookingType: this.selectedServiceType,
            newCustomer: 1,
            discount: this.newbookingData.discount,
    
          }
    
          
        }
        Object.keys(data.bookingStatusInfo).forEach(key => {
          if ((data.bookingStatusInfo as any)[key] === null) {
            delete (data.bookingStatusInfo as any)[key];
          }
        });
        data.bookingStatusInfo.completedServices.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.bookingStatusInfo.products.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.bookingStatusInfo.custom_items.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        console.log(data);
        this.loaderservice.showLoader = true
        this.apiservice.updateBookingStatusWithInvoice(data)
      }  
      else {
        
    
        this.productInfo = this.completedProducts.map((item:any) => {
          return {
            "product_name": item.product_name,
            "product_desc": item.description,
            "entity_product_hash": item.hash_id,
            "product_img_url": item.img_url,
            "product_price": item.price,
            "product_qty": item.total_completed_services_qty,
            "tax_slab_hash": item.tax_slab_hash,
            "hsn_code": item.product_hsn_code,
            "inventory_item_hash": item.inventory_item_hash,
            "purchase_unit": item.purchase_unit,
            "selling_unit": item.selling_unit,
            "selling_purchase_multiplier": item.selling_purchase_multiplier,
            "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            "selling_quantity": Math.round((+item.qty_info*item.total_completed_services_qty)*100)/100,
            "purchase_quantity": Math.round(((+item.qty_info*item.total_completed_services_qty)/item.selling_purchase_multiplier)*100)/100,
          }
        })
    
    
        let data = {
          "customer_name": this.newbookingData.customerName ? this.newbookingData.customerName : 'New Customer',
          "customer_phone": this.newbookingData.customerPh ? this.newbookingData.customerPh : '0000000000',
          "customer_country_code": this.selectedCountryCode.dial_code,
          "entity_hash": this.selectedBusiness.hash_id,
          "services": this.completedServices,
          "products": this.productInfo,
          "custom_items": this.form.get('items')!.value.map((item:any) => {
            return {
              "item_name": item.name.item_name ?  item.name.item_name : item.name, 
              "item_desc": item.name.item_desc ?? '', 
              "item_inventory_hash": item.name.hash_id ?? '', 
              "item_img_url": item.name.image_thumb_url ?? '', 
              "item_qty": item.count, 
              "item_price": +item.price,
              "tax_slab_hash": item.tax_slab == 'default' ? null : item.tax_slab
            }
          }),
          "price": this.newbookingData.price,
          "discount": this.newbookingData.discount,
          "assignedToHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
          "assignedByHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
          "created_by_hash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          "creation_date": this.formatDateString1(this.selectedDate)
    
          
        }
        Object.keys(data).forEach(key => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });
    
     
        data.services.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.products.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        data.custom_items.forEach((element:any) => {
          Object.keys(element).forEach(key => {
            if ((element as any)[key] === null) {
              delete (element as any)[key];
            }
          });
          
        });
        console.log(data);
        this.loaderservice.showLoader = true
        if(this.isEntityForeign == '0'){
          this.apiservice.addEditEntityInvoiceWithoutBooking(data)
    
        }
        else if(this.isEntityForeign == '1'){
          this.apiservice.addEditInternationalEntityInvoiceWithoutBooking(data)
        }
      }  
    }

    formatDate1(dateStr:Date) {

      let curdate = new Date(dateStr).toLocaleString('en-CA', {
        timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
    }).slice(0, 10);
    
        return curdate
    }
    tConv24(time24: any) {
      let ts: any = time24;
      let H: any = +ts.substr(0, 2);
      let h: any = H % 12 || 12;
      h = h < 10 ? '0' + h : h; // leading 0 at the left for 1 digit hours
      var ampm = H < 12 ? ' AM' : ' PM';
      ts = h + ts.substr(2, 3) + ampm;
      return ts;
    }
    addOneHourAndFormat(date: Date): string {
      const newDate = new Date(date);
      newDate.setHours(date.getHours() + 1);
    
      const hours = newDate.getHours().toString().padStart(2, '0');
      const minutes = newDate.getMinutes().toString().padStart(2, '0');
    
      return `${hours}:${minutes}`;
    }
    
    formatDateString(inputDateString: Date): string {
      const inputDate = new Date(inputDateString);
      const year = inputDate.getFullYear();
      const month = (inputDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
      const day = inputDate.getDate().toString().padStart(2, '0');
      const hours = inputDate.getHours().toString().padStart(2, '0');
      const minutes = inputDate.getMinutes().toString().padStart(2, '0');
      const seconds = inputDate.getSeconds().toString().padStart(2, '0');
    
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    formatTime(date: Date): string {
      const hours = date.getHours().toString().padStart(2, '0'); // Ensure two digits, pad with leading zero if necessary
      const minutes = date.getMinutes().toString().padStart(2, '0'); // Same for minutes
      return `${hours}:${minutes}`;
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }


  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"https://www.youtube.com/embed/AlsuB-i64RY?si=uNA-X1wNJpxGxEEx",
      title: 'Generating Bills & Invoices in LookzUp Web Portal.'
    }})
    }

    opencontact(){
      this.router.navigate(['/contact-us']);
    }

    getOneHourSlot(date:Date) {
      // Convert to local time string in 24-hour format
      const localTimeString = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    
      // Get hours and minutes
      let [hours, minutes] = localTimeString.split(':').map(Number);
    
      // Adjust hours based on minutes (round down to nearest hour)
      let startHour = hours;
    
      // Calculate next hour
      let endHour = (startHour + 1) % 24;
    
      // Format hours to always be 2 digits (e.g., 08:00, 23:00)
      const formatHour = (hour:any) => hour.toString().padStart(2, '0');
    
      // Return the 1-hour slot in 24-hour format
      return {
        start: `${formatHour(startHour)}:00`,
        end: `${formatHour(endHour)}:00`
      };
    }
    calculateDiscount(){
      this.newbookingData.discount = 0
      
      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.selectedServiceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount = this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.selectedServiceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);
  
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount = this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
              // virtual service
              else if (this.selectedServiceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);
  
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount = this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.selectedServiceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  this.newbookingData.discount = this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.selectedServiceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  this.newbookingData.discount = this.discountInfo.discountAmount;
                }
              }
              // virtual service
              if (this.selectedServiceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  this.newbookingData.discount = this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }

      this.newbookingData.discount = +this.newbookingData.discount.toFixed(2) 
    }

    isCurrentDateInRange(start_date: string, end_date: string): boolean {
      const currentDate = new Date();
      const startDate = new Date(start_date);
      const endDate = new Date(end_date);
  
      // Normalize the dates by setting the time to 00:00:00
      const normalizeDate = (date: Date): Date => {
          return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      };
  
      const normalizedCurrentDate = normalizeDate(currentDate);
      const normalizedStartDate = normalizeDate(startDate);
      const normalizedEndDate = normalizeDate(endDate);
  
      // Check if the current date is between start and end date (inclusive)
      return normalizedCurrentDate >= normalizedStartDate && normalizedCurrentDate <= normalizedEndDate;
  }

  // Create a new form group for each item
itemOptions: string[] = ['Item1', 'Item2', 'Item3', 'Item4'];  // List of options
filteredOptions: Observable<any[]>[] = [];
createItem(): FormGroup {
const itemGroup = this.fb.group({
  name: ['', Validators.required],
  price: ['', Validators.required],
  count: [1, Validators.required],
  tax_slab: ['default']
});

const filterControl = itemGroup.get('name') as FormControl;

// Listen for changes, trigger API call if length > 3
// const filteredOption = filterControl.valueChanges.pipe(
//   debounceTime(300),  // Add debounce to reduce API calls
//   filter(value => value.length > 2),  // Only call API if input length > 3
//   switchMap(value => this.fetchOptions(value))  // Fetch options from API
// );


const priceControl = itemGroup.get('price') as FormControl;

// Store the previous value to subtract when the value changes
let previousPrice = 0;

priceControl.valueChanges.subscribe(value => {
    // Convert the input value to a number
    const parsedValue = +value;
  if (!isNaN(parsedValue) && value && value !== '' && value !== undefined) {
    // Subtract the previous price before adding the new one
    this.newbookingData.price = this.newbookingData.price - previousPrice + (+value);

    // Update the previous price to the new value for future changes
    previousPrice = +value;
  }
  else{

  }

  this.calculateDiscount()
});

// this.filteredOptions.push(filteredOption);
// console.log(this.filteredOptions);

return itemGroup;

}

displayItemName(item: any): string {
return item ? item.item_name : '';  // Return only the item_name for display
}

// Call the API to fetch options based on the user's input
fetchOptions(value: string): Observable<string[]> {
  // Example API call: Replace with your actual API endpoint
  return this.http.get<string[]>(`https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.selectedBusiness.hash_id}&searchKey=${value}&pageNo=1&count=25`);
}

// Filter the autocomplete options based on the user's input
private _filter(value: string): string[] {
  const filterValue = value.toLowerCase();
  return this.itemOptions.filter(option => option.toLowerCase().includes(filterValue));
}

// Get the form array of items
get items(): FormArray {
return this.form.get('items') as FormArray;
}

// Add new form field
addFormField(): void {
this.items.push(this.createItem());
}

// Remove a form field by index
removeFormField(index: number): void {
this.newbookingData.price -= +this.items.at(index).value.price

 
this.items.removeAt(index);
this.calculateDiscount()
}

// Decrease the count and remove the form if count becomes 0
decreaseCount(index: number): void {
  const currentItem = this.items.at(index);
  const currentCount = currentItem.get('count')!.value;

  if (currentCount > 1) {
    currentItem.get('count')!.setValue(currentCount - 1);
  } else {
    // this.newbookingData.price -= +currentItem.get('price')!.value
    this.removeFormField(index);  // Remove the form when count is 0

  }
  
}

// Increase the count
increaseCount(index: number): void {
  const currentItem = this.items.at(index);
  currentItem.get('count')!.setValue(currentItem.get('count')!.value + 1);
}
// firstTimeBelow3:boolean = false;
// filteredList:any = []
// searchNameData(){
//   this.isDropdownSelected = false
//   if(this.newbookingData.customerName.length >= 3){
//     this.firstTimeBelow3 = true
//     this.apiservice.getFitnessEnrolledMemberForAutoCorrect(this.selectedBusiness.hash_id,this.newbookingData.customerName);

//   }
//   else{
//     if (this.firstTimeBelow3) {
//     this.firstTimeBelow3 = false
//     this.filteredList =  []
//     // this._apiService.getFitnessEnrolledMemberForAutoCorrect(this.parentData.data.entityHash,'');

//     }
//   }
// }
selectedMember:any
isDropdownSelected:boolean = false
onClickName(item:any){
  this.selectedMember = item
  this.newbookingData.customerName = item.name
  this.selectedCountryCode= this.countryList.find(country => country.dial_code === item.country_code)
  this.newbookingData.customerPh = item.phone
  this.isDropdownSelected = true
}

selectcountry(){
  let dialogref = this.dialog.open(SelectBusinessCountryComponent,{
  width:'500px',
  disableClose:true,
  data:{
    link:"",
    title: 'Select business country',
    ref: this.dialog
  }})
  dialogref.afterClosed().subscribe(res => {
    if(res){
      this.router.navigate(['purchased-plan']);
    }
  } 
  )
  }

  completedProducts:any = []
  selectProducts(item:any){
    console.log(item);
    if(item.service_type_hash){ // being added from api list
      console.log(item);
      
      const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.service_type_hash);
      console.log(index);

      if(index != -1){
       
        this.completedJobs.push(item)
        this.newbookingData.price += item.price
        
        this.serviceList[index].toShow = false
      }
      
      // this.serviceList[index].current_status = 3
     
      
    }


    else if(item.hash_id){ // being added from my list
      const index = this.productsList.findIndex( (x:any)=>x.hash_id == item.hash_id);


    let data = {
      hash_id: item.hash_id,
      product_name: item.product_name,
      price: (this.selectedServiceType == '0') 
      ? (item.discount_status == 1 ? item.home_discounted_price : item.home_price)
      : (this.selectedServiceType == '1' ? (item.discount_status == 1 ? item.shop_discounted_price : item.shop_price)
      : (item.discount_status == 1 ? item.virtual_discounted_price : item.virtual_price) ) ,

      img_url: item.thumb_image_url,
    
      description: item.product_desc,
      total_completed_services_qty: 1,
      "tax_slab_hash": item.tax_slab_hash,
      "product_hsn_code": item.product_hsn_code,
      "inventory_item_hash": item.inventory_item_hash,
      "purchase_unit": item.purchase_unit,
      "selling_unit": item.selling_unit,
      "selling_purchase_multiplier": item.selling_purchase_multiplier,
      "qty_info": item.qty_info,

    }

    this.completedProducts.push(data)
    this.newbookingData.price += data.price
    this.productsList[index].toShow = false
    }
    
    // console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount()
  }


  decreaseProductCount(item:any,index:any){
    if(this.completedProducts[index].total_completed_services_qty == 1){
  
      const index1 = this.productsList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      // console.log(this.productsList[index].price);
      // console.log(this.completedProducts[index].total_completed_services_qty);
      // console.log(this.newbookingData.price);
      
      this.newbookingData.price -= this.completedProducts[index].price/this.completedProducts[index].total_completed_services_qty
      this.productsList[index1].toShow = true
      this.completedProducts.splice(index,1)
    }
    
    else{
    


      this.newbookingData.price -= this.completedProducts[index].price/this.completedProducts[index].total_completed_services_qty

       
      this.completedProducts[index].price -= this.completedProducts[index].price/this.completedProducts[index].total_completed_services_qty 
      this.completedProducts[index].total_completed_services_qty--
    }
    this.calculateDiscount()
  }


  increaseProductCount(item:any,index:any){
    this.newbookingData.price += item.price/item.total_completed_services_qty
  


    item.price += item.price/item.total_completed_services_qty 
    item.total_completed_services_qty++
    this.calculateDiscount()
  }

  removeCompletedProducts(item:any){
    
    const index = this.productsList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    const index1 = this.completedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

    this.newbookingData.price -= this.completedProducts[index1].price
    this.productsList[index].toShow = true
    this.completedProducts.splice(index1,1)
    this.calculateDiscount()
  }

  formatDateString1(datestr: Date): string {
    const now = new Date(datestr);
    
    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false, // Ensures 24-hour format
    };
  
    const formattedDate = new Intl.DateTimeFormat('en-CA', options).formatToParts(now);
  
    let year = '', month = '', day = '', hours = '', minutes = '', seconds = '';
  
    formattedDate.forEach(part => {
      if (part.type === 'year') year = part.value;
      if (part.type === 'month') month = part.value;
      if (part.type === 'day') day = part.value;
      if (part.type === 'hour') hours = part.value;
      if (part.type === 'minute') minutes = part.value;
      if (part.type === 'second') seconds = part.value;
    });
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


  // ------------ CUSTOMER NAME AUTOCOMPLETE ---------------
  firstTimeBelow3:boolean = false;
  loaderForAutocomplete:boolean = false
  debounceTimer: any;  // Declare this at the class level
  autocompleteItems:any = []

  searchCustomerName(event:any) {
    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }
    const ignoredKeys = [
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Shift', 'Control', 'Alt', 'Meta', 'Tab', 'Escape'
    ];
  
    if (ignoredKeys.includes(event.key)) {
      return;
    }

    clearTimeout(this.debounceTimer);  // Clear previous timer
  
    this.debounceTimer = setTimeout(() => {
      const value = this.newbookingData.customerName ?? '';
      console.log(value);
      
      if (value.length >= 3) {
        console.log('holfirst');
        this.loaderForAutocomplete = true
        this.firstTimeBelow3 = true;
        this.apiservice.getCustomerListForAutoComplete(value,this.selectedBusiness.hash_id);
      } else {
        if (this.firstTimeBelow3) {
          console.log('holsecond');
          this.autocompleteItems = [];
          this.firstTimeBelow3 = false;
        }
      }
    }, 300); // Delay in ms
  }

  selectSearchResult(customer:any){
    this.autocompleteItems = [];
    this.newbookingData.customerName = customer.name
    this.selectedCountryCode = this.countryList.find(
    (country) => country.dial_code === customer.country_code
  );
    this.newbookingData.customerPh = customer.phone
  }

  getSectionVisibleStatus(access_key: string) {
    if (this.selectedBusiness.is_owner == 1) {
      return true;
    } else {
      const list = this.selectedBusiness.employee_functionality_list;
      if (!Array.isArray(list)) return false;

      const found = access_key
      return this.selectedBusiness[found] === 1 ? true : false;
    }
  }

  get isSubmitDisabled(): boolean {
  const items = this.form.get('items') as FormArray;
  
  return (
    (!this.newbookingData.price &&
      this.completedJobs.length === 0 &&
      this.completedProducts.length === 0 &&
      items.length === 0) ||
      this.formChecker()
      || !this.endTime || !this.startTime || this.checkIfEmpty() || this.form.invalid || this.checkIfEmptyForProduct()
  );
}


}
